import React from 'react';
import { formatCodeAmount } from '../../utils/analytics';

const TopBilledMembersBody = ({ members = [] }) => {
  if (members.length === 0) {
    return <span className="top-billed-members__empty">No billed members</span>;
  }

  return (
    <div className="top-billed-members">
      <div className="top-billed-members__rows">
        {members.map((member) => (
          <div key={member.subscriberId} className="top-billed-members__row">
            <span className="top-billed-members__name">{member.name}</span>
            <span className="top-billed-members__amount">{formatCodeAmount(member.totalAmount)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopBilledMembersBody;
